import { TypedStore, UntypedStore } from '~/store';

export const useTypedStore = useStore as () => TypedStore;
export const useUntypedStore = useStore as () => UntypedStore;
